import { render, staticRenderFns } from "./PartnerHome.vue?vue&type=template&id=8f8a361e&scoped=true"
import script from "./PartnerHome.vue?vue&type=script&lang=ts"
export * from "./PartnerHome.vue?vue&type=script&lang=ts"
import style0 from "./PartnerHome.vue?vue&type=style&index=0&id=8f8a361e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8a361e",
  null
  
)

export default component.exports